import { Component, OnInit } from '@angular/core';
import { MonitoringService } from './shared/monitoring/monitoring.service';
import { AuthObservabilityService } from './shared/monitoring/auth-observability.service';
import { LoginService } from './login/login.service';
import { CurrentUser } from './login/current-user.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  private wasLoggedIn = false;

  constructor(
    private readonly monitoring: MonitoringService,
    private readonly authObservability: AuthObservabilityService,
    private readonly loginService: LoginService
  ) {}

  ngOnInit(): void {
    this.monitoring.bootstrap().then(() => {
      this.loginService.currentUser$.subscribe((user) => this.onUserChanged(user));
    });
  }

  private onUserChanged(user: CurrentUser | null): void {
    if (user) {
      this.monitoring.identify(user.email, user.roleIds?.join(';'));
      this.monitoring.startNewSession();
      this.wasLoggedIn = true;
      return;
    }

    if (this.wasLoggedIn) {
      this.authObservability.trackLogout();
      this.wasLoggedIn = false;
    }
  }
}
